import React from "react";

// Labelled form field: <input> by default, or a <select> when `options` is
// given. Shows a hint under the field, or the error in its place.
// See FRONTEND/DESIGN-SYSTEM.md.
//
//   <Field label="Full name" name="name" value={v} onChange={set} />
//   <Field label="Occupation" name="profession" options={[["", "Select"], ...]} />
export default function Field({
  label,
  name,
  hint,
  error,
  options,
  className = "",
  ...rest
}) {
  const id = rest.id ?? `field-${name}`;
  const describedBy = error || hint ? `${id}-note` : undefined;
  const control = options ? (
    <select id={id} name={name} className="yc-input" aria-invalid={!!error} aria-describedby={describedBy} {...rest}>
      {options.map(([value, text]) => (
        <option key={value} value={value}>
          {text}
        </option>
      ))}
    </select>
  ) : (
    <input id={id} name={name} className="yc-input" aria-invalid={!!error} aria-describedby={describedBy} {...rest} />
  );

  return (
    <div className={`yc-field ${error ? "has-error" : ""} ${className}`}>
      <label htmlFor={id} className="yc-label">
        {label}
      </label>
      {control}
      {(error || hint) && (
        <p id={`${id}-note`} className={error ? "yc-error" : "yc-hint"}>
          {error || hint}
        </p>
      )}
    </div>
  );
}
